export const ROLES = {
  SUPERVISOR: "supervisor",
  CAPITAN: "capitan",
  ADMIN: "admin",
  AMBOS: "ambos",
};
